module.exports = __webpack_public_path__ + "img/btn.63c21e2e.png";